import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, Input } from '@angular/core';
import { ListService } from '../../../../shared/services/list.service';
import { UserService } from '../../../../services/user.service';
import { TableModule } from 'primeng/table';
import { FieldsetModule } from 'primeng/fieldset';
import { Subscription } from 'rxjs';
import { LookupService } from '../../../../services/lookup.service';

@Component({
    selector: 'ppl-timesheet-edit-history-view',
    templateUrl: './timesheet-edit-history-view.component.html',
    styleUrls: ['./timesheet-edit-history-view.component.css'],
    standalone: true,
    imports: [
        TableModule,
        FieldsetModule
    ],
})
export class TimesheetEditHistoryViewComponent implements OnInit, OnDestroy {

    @Input() timesheetId!: number;
    timesheetEditHistoryData: any[] = [];
    private programName!: string;
    private listDataSub!: Subscription;
    groupedTimesheetEditHistoryData: any[] = [];
    dispositionReason: any[] = [];
    timesheetDisposition: any[] = [];


    constructor(
        private listService: ListService,
        private userService: UserService,
        private lookupService: LookupService
    ) {
    }

    ngOnInit(): void {
        const selectedProgram = this.userService.getSelectedProgram();
        this.dispositionReason = this.lookupService.getLookupValue('Disposition Reason');
        this.timesheetDisposition = this.lookupService.getLookupValue('TimeSheet Disposition');
        this.programName = selectedProgram?.program_code ?? '';
        this.getTimesheetEditHistory();
    }

    getTimesheetEditHistory() {
        const payload: any = {
            pageName: 'timesheet-processCode-history',
            programCode: this.programName,
            condition: 'and',
            recordsPerPage: 20,
            startingPageNumber: 1,
            searchParam: [
                {
                jsonPath: 'timesheetId',
                value: this.timesheetId,
                operator: 'Equal',
                },
            ],
            orderByColumn: [],
            orderBy: ['desc'],
        }
        if (!this.timesheetId) {
            return;
        }
        this.listDataSub = this.listService.getListData(payload, 'claims').subscribe(data => {
            const responseData = data?.responsedata;
            this.timesheetEditHistoryData = responseData || [];
            this.timesheetEditHistoryData.forEach((e: any) => {
                if (e.reasonLkp) {
                    e.reason = this.dispositionReason.filter((d: any) => d.lkpValueCode == e.reasonLkp)[0].lkpValueName;
                }

                if (e.dispositionLkp) {
                    e.disposition = this.timesheetDisposition.filter((d: any) => d.lkpValueCode == e.dispositionLkp)[0].lkpValueName
                }
            });
            this.groupByRunDate();
        })
    }

    groupByRunDate() {
        const groupedByRunDate = this.timesheetEditHistoryData.reduce((acc, item) => {
        const key = item.runDate ?? null;
        if (!acc[key]) {
            acc[key] = { runDate: item.runDate, items: [] as any[] };
        }
            acc[key].items.push(item);
            return acc;
        }, {} as Record<string, { runDate: string; items: any[] }>);

        const groupedArray = Object.values(groupedByRunDate);
        this.groupedTimesheetEditHistoryData = groupedArray;
    }

    ngOnDestroy(): void {
        if (this.listDataSub) {
            this.listDataSub.unsubscribe();
        }
    }
}